<template>
<div class="popup" v-cloak v-show="viewLogsShow">
    <div class="content" id="viewLogs" v-if="!moreTransferFlag" :style="{height:getHeight()}">
        <div class="title">
            {{$t('language.popup.taskListPopup.viewLogs')}}
            <div class="icon white-close dialog-close" @click="closePage()"></div>
        </div>
        <div>
            <!-- 单源单目标传输界面 -->
            <div class="view-logs-body" v-if="singleTransferFlag">
                <div class="log-line">
                    <div class="view-name" v-if="viewDetail.tasks[0].type==1">{{$t('language.cloudTransfer.transfer')}}: </div>
                    <div class="view-name" v-else>{{$t('language.common.sync')}}: </div>
                    <div class="log-category-link" v-show="viewDetail.tasks[0].branchType!='share'" :title="viewDetail.tasks[0].fromItem.nodes|getCatalog|getCatalogTitle" @click.stop="toSourceCatalog(viewDetail.tasks[0].fromItem)">{{viewDetail.tasks[0].fromItem.nodes|getCatalog}}</div>
                    <div class="log-category-link" v-show="viewDetail.tasks[0].branchType=='share'" :title="viewDetail.tasks[0].fromItem.nodes|getCatalogShare|getCatalogTitle" @click.stop="toSharelicLink(viewDetail.tasks[0].fromItem)">{{viewDetail.tasks[0].fromItem.nodes|getCatalogShare}}</div>
                </div>
                <div class="log-line">
                    <div class="view-name"  v-if="viewDetail.tasks[0].type==1">{{$t('language.common.minTo')}}: </div>
                    <div class="view-name" v-else>{{$t('language.common.with')}}: </div>
                    <div class="log-category-link" :title="viewDetail.tasks[0].toItem.nodes|getCatalog|getCatalogTitle" @click.stop="toAimCatalog(viewDetail.tasks[0].toItem)">{{viewDetail.tasks[0].toItem.nodes|getCatalog}}</div>
                </div>
                <div class="log-line" v-if="showStatus(viewDetail.tasks[0])=='failure'">
                    {{$t('language.common.result')}}: {{$t('language.common.failure')}}
                </div>
                <div class="log-line" v-if="showStatus(viewDetail.tasks[0])=='partialSuccess'">
                    {{$t('language.common.result')}}: {{$t('language.common.partialSuccess')}}
                </div>
                <div class="log-line" v-if="showStatus(viewDetail.tasks[0])=='success'">
                    {{$t('language.common.result')}}: {{$t('language.common.success')}}
                </div>
                 <div class="log-line" v-if="showStatus(viewDetail.tasks[0])=='cancel'">
                    {{$t('language.common.result')}}: {{$t('language.common.canceled')}}
                </div>
                <div class="log-line">
                    <div v-if="viewDetail.type==2&&viewDetail.tasks[0].lastLog" class="log-line-sync">
                        {{$t('language.common.fileProcess')}}: Add[{{viewDetail.tasks[0].lastLog.addFile}}]&nbsp;Update[{{viewDetail.tasks[0].lastLog.updateFile}}]&nbsp;Delete[{{viewDetail.tasks[0].lastLog.deleteFile}}]
                    </div>
                    <div v-if="viewDetail.type==1&&viewDetail.tasks[0].lastLog" class="log-line-left">
                        {{$t('language.common.fileProcess')}}: {{viewDetail.tasks[0].lastLog.readyTranFileCount}}/{{viewDetail.tasks[0].lastLog.totalFileCount}}
                    </div>
                </div>
                <div class="log-line" v-if="viewDetail.tasks[0].lastLog">
                    <div class="log-line-left">
                        {{$t('language.common.dataProcess')}}: {{viewDetail.tasks[0].lastLog.fileTotalReadedBytes|formatByte}}/{{viewDetail.tasks[0].lastLog.totalBytes|formatByte}}
                    </div>
                </div>
                <div class="log-line" v-if="viewDetail.tasks[0].lastLog">
                    <div class="log-line-left">
                        {{$t('language.common.startTime')}}: {{viewDetail.tasks[0].lastLog.taskStartTimeStr}}
                    </div>
                    <div class="log-line-right"  v-if="viewDetail.tasks[0].lastLog">
                        {{$t('language.common.endTime')}}: {{viewDetail.tasks[0].lastLog|getEndTime}}
                    </div>
                </div>
                <div class="log-line" v-if="viewDetail.tasks[0].lastLog">
                    <div class="log-line-left">
                        {{$t('language.common.averageRateSpecial')}}: {{(viewDetail.tasks[0].lastLog.fileTotalReadedBytes/(viewDetail.tasks[0].lastLog.taskElaspedTimeLong/1000))|formatByteSpeed}}
                    </div>
                    <div class="log-line-right">
                        {{$t('language.common.executedTimes')}}: {{viewDetail.tasks[0].runCount}}
                    </div>
                </div>
                <div class="log-line" v-if="viewDetail.tasks[0].lastLog&&viewDetail.tasks[0].lastLog.totalBytes&&viewDetail.tasks[0].lastLog.fileTotalReadedBytes==viewDetail.tasks[0].lastLog.totalBytes">
                    {{$t('language.common.fileSuccess')}}
                </div>
                <div class="log-line" v-if="viewDetail.tasks[0].lastLog&&viewDetail.tasks[0].lastLog.errorList.length">
                    <div class="log-line-left click-log-red" @click="openFailedFiles()"> {{$t('language.common.viewFailed')}}</div>
                    <div class="log-line-right click-log-blue" v-if="viewDetail.type==1&&!viewDetail.retryed" @click="retryAll()"> {{$t('language.common.retryAll')}}</div>
                    <div class="log-line-right click-log-blue" v-if="viewDetail.type==1&&viewDetail.retryed" @click="toAimRootCatalog()"> {{$t('language.common.viewProgress')}}</div>
                </div>
            </div>
        </div>
        <!-- 默认加载界面 -->
        <div v-if="loading" class="view-logs-body" v-loading="loading">

        </div>
        <!-- 若任务还没开始运行界面 -->
        <div v-if="nonFlag" class="view-non-body">
            {{$t('language.common.taskNotRun')}}
        </div>
    </div>

    <!-- 多源传输界面 -->
    <div class="content" id="viewLogs2" v-if="moreTransferFlag">
        <div class="title">
            {{$t('language.popup.taskListPopup.viewLogs')}}
            <div class="icon white-close dialog-close" @click="closePage"></div>
        </div>
        <!-- 默认加载界面 -->
        <div v-if="loading" class="view-logs-body" v-loading="loading">
        </div>
        <div class="view-logs-all">
            <div class="view-logs-body">
                <div class="logs-detail-box progress-box-height" v-for="(item, index) in viewDetail.tasks" :key="index"  :class="getHeight(item,index)">
                    <div class="view-logs-info">
                        <div style="width:210Px;float:left;">
                            <div class="view-logs-catelog">
                                <div style="float:left;">{{$t('language.common.from')}}:</div>
                                <div class="view-logs-category-link" v-show="item.branchType!='share'&& item.branchType!='businessTransfer'" @click.stop="toSourceCatalog(item.fromItem)" :title="item.fromItem.nodes|getCatalog|getCatalogTitle">{{item.fromItem.nodes|getCatalog}}</div>
                                <div class="view-logs-category-link" v-show="item.branchType=='businessTransfer'" @click.stop="toSourceCatalog(item.fromItem)" :title="item.fromItem.fromEmail">{{item.fromItem.fromEmail}}</div>
                                <div class="view-logs-category-link" v-show="item.branchType=='share'" @click.stop="toSharelicLink(item.fromItem)" :title="item.fromItem.nodes|getCatalogShare|getCatalogTitle">{{item.fromItem.nodes|getCatalogShare}}</div>
                            </div>
                            <div class="view-logs-catelog" v-if="item.type==1">
                                <div v-if="item.branchType!='businessTransfer'">
                                    <div style="float:left;">{{$t('language.common.to')}}:</div>
                                    <div class="view-logs-category-link" @click.stop="toAimCatalog(item.toItem)" :title="toNodes|getCatalog|getCatalogTitle">{{toNodes|getCatalog}}</div>
                                </div>
                                <div v-else> 
                                     <div style="float:left;">{{$t('language.common.to')}}:</div>
                                     <div class="view-logs-category-link" @click.stop="toAimCatalog(item.toItem)" :title="item.toItem.toEmail">{{item.toItem.toEmail}}</div>
                                </div>
                           </div>
                            <div class="view-logs-catelog" v-if="item.type==2">
                                <div style="float:left;">{{$t('language.common.with')}}:</div>
                                <div class="view-logs-category-link" @click.stop="toAimCatalog(item.toItem)" :title="item.toItem.nodes|getCatalog|getCatalogTitle">{{item.toItem.nodes|getCatalog}}</div>
                            </div>
                        </div>
                        <div style="width:210Px;float:left;height:100%;">
                            <div v-if="showStatus(item)=='success'">
                                <div class="icon-util task-success logs-failure-icon-position"></div>
                                <div style="float:left;">{{$t('language.common.success')}}</div>
                            </div>
                            <div v-if="showStatus(item)=='failure'">
                                <div class="icon-util task-failure logs-failure-icon-position"></div>
                                <div style="float:left;">{{$t('language.common.failure')}}</div>
                            </div>

                            <div v-if="showStatus(item)=='partialSuccess'">
                                <div class="icon-util task-patial logs-status-icon-position"></div>
                                <div style="float:left;">{{$t('language.common.partialSuccess')}}</div>
    
                            </div>
                            <div v-if="showStatus(item)=='cancel'">
                                <div class="icon-util task-failure logs-status-icon-position"></div>
                                <div style="float:left;">{{$t('language.common.canceled')}}</div>
                            </div>
                            
                        </div>
                        <div> </div>
                        <div class="icon-util  view-collapse-positopn" :class="clickCurrent == index?'collapse-up':'collapse-down'" @click="collapse(index,item)"> </div>
                        <viewlogsDetail  ref="viewlogsDetail" :clickCurrent=clickCurrent :index=index :itemDetail='item'> </viewlogsDetail>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import viewlogsDetail from "@/components/common/tabs/tabs_detailed_progress/tab_logs_detail";
import taskListUtils from "@/js/workspace/task_list_util.js";
import commonUtils from "@/js/workspace/common_util.js";
export default {
    components: {
        viewlogsDetail
    },
    data: function () {
        return {
            viewLogsShow: false,
            viewDetail:{},
            nonFlag: false,
            singleTransferFlag: false,
            loading: true,
            toNodes: '',
            clickCurrent: -1,
            moreTransferFlag: false
        }
    },
    methods: {
        getHeight(){
          let height;
          if(this.nonFlag){
              height=140+'Px';
          }else{
              height=350+'px';
          }
          if(this.viewDetail.tasks&&this.viewDetail.tasks[0]){
              height=300+'px';
          }
          return height;
        },
        toAimCatalog(item) {
            this.$parent.toAimCatalog(item);
        },
        toSourceCatalog(item) {
            this.$parent.toSourceCatalog(item);
        },
        collapse(index,item) {
            //console.log(item);
            let that=this;
            if (this.clickCurrent != index) {
                this.clickCurrent = index;
                if(!item.lastLog){
                   let  getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, item.id, null);
                    this.Utils.doTasksRequest("get", getData).then(result => {
                        if (result.status == 200) {
                            if(!item.getViewLogCount){
                                    item.getViewLogCount=0;
                                }
                            item.getViewLogCount=item.getViewLogCount+1;
                            if(result.tasks[0].lastLog){
                                item.lastLog=result.tasks[0].lastLog;
                            }
                              that.viewDetail.tasks[index]=item;
                                Vue.set(that.viewDetail.tasks, index, item);
                                that.$nextTick(()=>{
                                   that.$refs.viewlogsDetail[index].updatePage(item);
                                })
                                that.$forceUpdate();
                        }
                    });
                }
            } else {
                this.clickCurrent = -1;
            }
        },
        openFailedFiles() {
            let that = this;
            let failedFilesDialog = this.$parent.$refs.failedFilesDialog;
            let errorList = this.viewDetail.tasks[0].lastLog.errorList;
            let task = that.viewDetail.tasks[0];
            failedFilesDialog.transferType = this.viewDetail.type;
            failedFilesDialog.selectedArr = [];
            failedFilesDialog.unfinishData = Object.assign([], errorList);
            $.each(failedFilesDialog.unfinishData, function (index, item) {
                item.fromItem = Object.assign([], task.fromItem);
                item.toItem = Object.assign([], task.toItem);
                item.options = task.options;
            });
            that.$forceUpdate();
            failedFilesDialog.retryFailedShow = true;
        },
        retryAll() {
            let that = this;
            let failedFilesDialog = this.$parent.$refs.failedFilesDialog;
            let errorList = this.viewDetail.tasks[0].lastLog.errorList;
            let task = that.viewDetail.tasks[0];
            failedFilesDialog.selectedArr = Object.assign([], errorList);
            failedFilesDialog.unfinishData = Object.assign([], errorList);
            $.each(that.$parent.$refs.failedFilesDialog.selectedArr, function (index, item) {
                item.fromItem = Object.assign([], task.fromItem);
                item.toItem = Object.assign([], task.toItem);
                item.options = task.options;
            });
            that.$parent.$refs.failedFilesDialog.retry();//调用父组件相关联的重试接口
            this.viewDetail.retryed = true;
            that.$forceUpdate();
        },
        toAimRootCatalog() {
            let toItem = Object.assign({}, this.viewDetail.tasks[0].toItem);
            let toItemJson = Object.assign({}, toItem);
            let rootNodes = toItemJson.nodes[toItemJson.nodes.length - 1];
            toItemJson.nodes = [];
            toItemJson.nodes.push(rootNodes);
            toItemJson.id = toItemJson.nodes[toItemJson.nodes.length - 1].fileId;
            if (toItemJson.nodes[toItemJson.nodes.length - 1].filename) {
                toItemJson.name = toItemJson.nodes[toItemJson.nodes.length - 1].filename;
            } else {
                toItemJson.name = toItemJson.nodes[toItemJson.nodes.length - 1].fileName;
            }
            $.each(toItemJson.nodes, function (i, item) {
                if (!item.fileName) {
                    item.fileName = item.filename;
                }
                item.tokenId = toItemJson.driveId;
            });
            this.closePage();
            this.$parent.toAimCatalog(toItemJson);
        },
        closePage() {//关闭界面
            this.viewLogsShow = false;
            $.each(this.viewDetail.tasks, function (taskIndex, taskItem) {
                taskItem.retryed = false;
            });
            this.viewDetail.retryed = false;
        },
        //点击分享链接
        toSharelicLink (item) {
            if(item.sharePath){
                this.$store.commit("setSharePath", JSON.parse(item.sharePath));
            }
            let link = item.shareUrl;
            window.open(link);
        },
        showStatus(item){
            let result=taskListUtils.showStatus(item);
            return result;
        },
        getHeight(item,index){
            if(this.clickCurrent==index){
            if(item.type!=1){
             return 'viewLog-box-more';
            }else{
                if(item.getViewLogCount&&item.getViewLogCount!=1){
                    return 'viewLog-box-min';
                }
                 return 'viewLog-box-more';
            }
            }else{
                return false;
            }
        }

    }
}
</script>

<style>
#viewLogs{
    width: 500px;
    /*no*/
    height: 390px;
    /*no*/
}

#viewLogs2 {
    width: 500px;
    /*no*/
    height: 406px;
    /*no*/
}

.view-logs-body {
    width: 100%;
    height: calc(100% - 40px);
    /*no*/
    box-sizing: border-box;
    padding: 15px;
    /*no*/
    font-size: 12px;
    /*no*/
    color: #6f7886;
    line-height: 21px;
    /*no*/

}

.view-logs-all {
    width: 100%;
    height: 348px;
    /*no*/
    overflow: auto;
}

/*定义滑块，内阴影及圆角*/

.view-logs-all::-webkit-scrollbar {
    width: 8px;
    /*no*/
    height: 8px;
    /*no*/
    background-color: #fff;
}

.view-logs-all::-webkit-scrollbar-thumb {
    border-radius: 5px !important;
    /*no*/
    background-color: #becae4 !important;
    display: block !important;
}

.view-non-body {
    width: 100%;
    height: 100px;
    /*no*/
    box-sizing: border-box;
    padding: 20px;
    /*no*/
    color: #6f7886;
    line-height: 60px;
    /*no*/
}

.log-line {
    width: 100%;
    float: left;
}

.log-category-link {
    color: #4281ff;
    float: left;
    width: 400px;
    /*no*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.view-logs-category-link {
    color: #4281ff;
    float: left;
    width: 160px;
    /*no*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.log-category-link:hover,
.view-logs-category-link:hover {
    color: #4281ff;
    text-decoration: underline;
    cursor: pointer;
}

.view-name {
    float: left;
    white-space: pre-wrap;
}

.log-line-left {
    float: left;
    width: 235px;
    /*no*/
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.log-line-sync {
    float: left;
    width: 100%;
    /*no*/
    white-space: nowrap;
}

.log-line-right {
    float: right;
    text-align: left;
    width: 210px;
    /*no*/
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

}

.click-log-red {
    font-size: 14px;
    /*no*/
    color: red;
}

.click-log-blue {
    font-size: 14px;
    /*no*/
    color: #659fff;
}

.click-log-red:hover,
.click-log-blue:hover {
    text-decoration: underline;
    cursor: pointer;
}

.logs-detail-box {
    width: 468px;
    /*no*/
    border: 1px solid #cdddf5;
    /*no*/
    position: relative;
    line-height: 40px;
    /*no*/
    margin-bottom: 10px;
    /*no*/
    box-sizing: border-box;
}

.view-collapse-positopn {
    float: right;
    top: 9px;
    /*no*/
    position: relative;
    cursor: pointer;
}

.view-logs-info {
    width: 468px;
    /*no*/
    height: 40px;
    /*no*/
    position: absolute;
    z-index: 3;
    font-size: 14px;
    /*no*/
    box-sizing: border-box;
    padding: 0px 10px 0px 10px;
    /*no*/
}

.view-logs-catelog {
    width: 100%;
    float: left;
    height: 20px;
    /*no*/
    font-size: 13px;
    /*no*/
    line-height: 20px;
    /*no*/
}

.logs-status-icon-position {
    position: relative;
    top: 12px;
    /*no*/
    margin-right: 5px;
    /*no*/
    float: left;
}

.logs-failure-icon-position {
    position: relative;
    top: 8px;
    /*no*/
    margin-right: 5px;
    /*no*/
    float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/task_list_popups/view_logs_popups.vue